// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__uSMFg","icon":"spinner_icon__ju5yX","spinner-circle":"spinner_spinner-circle__jgD0w"};